module.exports = __webpack_public_path__ + "static/media/customer-cloud.ba83b0bc.svg";